import { Textarea } from "@chakra-ui/react";
import { FieldComponentProps } from "./types";

export function FieldTextarea(props: FieldComponentProps) {
  return (
    <Textarea
      id={props.id}
      name={props.label}
      onChange={(event) => {
        props.updateValue({ label: props.label, value: event.target.value });
      }}
      value={props.value}
    />
  );
}
